import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React, {useEffect, useMemo} from "react";
import {useIframeMessenger} from "../../../Hooks/UseIframeMessenger"
import useLocation from "../../../Hooks/CurrentUrlHook";
import Settings from "../../../settings.json"

export const AiChatModal = observer(({}) => {
    const {aiStore, generalStore} = useStores();
    const location = useLocation()
    const iframeSrc = useMemo(() => `${Settings.iframeUrl}?v=${Date.now()}`, []);

    const { iframeRef, sendMessage } = useIframeMessenger({
        onMessage: (data) => {
            console.log('Got message from iframe:', data);
        },
        isTestMode: false,
    });
    useEffect(async() => {
        aiStore.sendMessageToIframe = sendMessage
    }, [sendMessage]);

    useEffect(async() => {
        if (aiStore.isChatOpen) {
            await aiStore.sendInitialValues(window.location.href, aiStore.sendMessageToIframe, false, generalStore.workspace)
        }
    }, [location]);

    useEffect(() => {
        const handleResize = () => {
            aiStore.moveChatPosition({ dx: 0, dy: 0 });
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <div style={{
            position: 'fixed',
            bottom: aiStore.position.y,
            right: aiStore.position.x,
            zIndex: 1298,
            maxHeight: aiStore.size('768px'),
            width: (aiStore.isSidebarOpen && aiStore.isChatOpen) ?  aiStore.size('758px') : aiStore.isChatOpen ?  aiStore.size('520px') : '120px',
            height: aiStore.isChatOpen ?  aiStore.size('90%') : '92px',
            transition: 'width 0.3s ease, height 0.3s ease, bottom 0.15s ease, right 0.15s ease',
            overflow: (aiStore.isSidebarOpen && aiStore.isChatOpen) ? 'visible' : 'hidden',
            transformOrigin: 'bottom right',
            display: aiStore.isChatOpen ? 'block' : 'none'
        }}>
            <div style={{
                maxHeight:   aiStore.size('738px'),
                width:  aiStore.size('758px'),
                height: '100%',
                position: 'absolute',
                bottom: 0,
                right: 0,
            }}>
                <iframe
                    ref={iframeRef}
                    src={iframeSrc}
                    title="Child App"
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                />
            </div>
        </div>
    );

});